import ThemeSettingsDataTable from "../../../components/dataTable/tables/ThemeSettingsDataTable";

function ThemeSettingsPageView() {
  return <ThemeSettingsDataTable />;
}

export default ThemeSettingsPageView;
